import {memo, useContext, useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {useParams} from "react-router-dom";
import Loading from "../../components/Loading";
import CustomBreadcrumbs from "../../components/Layout/Breadcrumbs";
import Support from "../../components/Layout/Support";
import FileLink from "../../components/FileLink";
import {useRequest} from "../../hooks/request.hook";
import {MenuContext} from "../../context/MenuContext";
import "./index.scss";


const ArticlePage = () => {
    const [loading, setLoading] = useState(true);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [article, setArticle] = useState(null);
    const {category_id, article_id} = useParams();
    const {activeCategory, activeParentSubCategory, activeParentCategory, searchLetter, prevCategory} = useContext(MenuContext);
    const {request} = useRequest();

    useEffect(() => {
        let newBreadcrumbs = [];

        if(activeParentCategory) {
            newBreadcrumbs.push({
                name: activeParentCategory.title,
                path: `/cat/${activeParentCategory.id}`
            });
        }

        if(activeParentSubCategory) {
            newBreadcrumbs = [
                ...newBreadcrumbs,
                {
                    name: activeParentSubCategory.title,
                    path: `/cat/${activeParentSubCategory.id}`
                }
            ];
        }

        if(searchLetter && prevCategory) {
            if(activeCategory && prevCategory === activeCategory.id) {
                newBreadcrumbs.push({
                    name: activeCategory.title,
                    path: `/cat/${activeCategory.id}`
                });
            }

            newBreadcrumbs.push({
                name: searchLetter,
                path: `/cat/${prevCategory}?abc=${searchLetter}`
            });
        } else if(activeCategory) {
            newBreadcrumbs.push({
                name: activeCategory.title,
                path: `/cat/${activeCategory.id}`
            });
        }

        setBreadcrumbs(newBreadcrumbs);
    }, [activeCategory, activeParentSubCategory, activeParentCategory, searchLetter, article]);

    useEffect(() => {
        if(category_id && article_id) {
            request({url: `/api/v1/wiki/article?categoryid=${category_id}&id=${article_id}`})
                .then(data => {
                    if (data.length) {
                        setArticle(data[0]);
                    }
                    setLoading(false);
                    window.scrollTo(0, 0);
                });
        } else {
            setLoading(false);
            window.scrollTo(0, 0);
        }
    }, [category_id, article_id]);

    return loading ?
        <Loading/> :
        <div className="article-page">
            <Helmet>
                <title>{article?.title || 'Статья не найдена' | 'Центр поддержки Info.RKF.Online'}</title>
                <meta name="description" content="Краткое описание статьи"/> {/*Подставить краткое описание из статьи*/}
            </Helmet>
            <CustomBreadcrumbs config={breadcrumbs}/>
            <h1 className="article-page__title">
                {article ? article.title : 'Статья не найдена'}
            </h1>
            {article &&
                <>
                    {!!article.files?.length &&
                        <div className="article-page__files">
                            {article.files.map(file =>
                                <FileLink file={file} key={file.url}/>
                            )}
                        </div>
                    }
                    <div className="article-page__content" dangerouslySetInnerHTML={{__html: article.body}}/>
                </>
            }
            <Support/>
        </div>
};

export default memo(ArticlePage);